import { render, staticRenderFns } from "./SectionTooltip.vue?vue&type=template&id=bf2c5f46&"
import script from "./SectionTooltip.vue?vue&type=script&lang=js&"
export * from "./SectionTooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports